import { render, staticRenderFns } from "./orderLook.vue?vue&type=template&id=775a8abe&scoped=true"
import script from "./orderLook.vue?vue&type=script&lang=js"
export * from "./orderLook.vue?vue&type=script&lang=js"
import style0 from "./orderLook.vue?vue&type=style&index=0&id=775a8abe&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "775a8abe",
  null
  
)

export default component.exports